import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ReturnListPdfRes;
export const ReturnListPdfTodo = createAsyncThunk('ReturnListPdf', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'pdf_return_list',
            data: {
                "vcrn_code": data,
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
            },
            headers: { "Content-Type": "application/json" }
        })
        return ReturnListPdfRes = res.data

    } catch (error) {
        return ReturnListPdfRes = error.response.data
    }
})


